// Affected-categories card with combined monthly-loss footer. Extracted
// verbatim from AuditPreview.jsx (W2b). Caller decides whether to render.
export default function PreviewCategories({
  leakCategoriesAffected,
  estimatedMonthlyLossMin,
  estimatedMonthlyLossMax,
}) {
  if (!leakCategoriesAffected || leakCategoriesAffected.length === 0) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 28 }} data-testid="preview-categories-card">
      <div className="sf-eyebrow" style={{ marginBottom: 14 }}>Affected categories</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {leakCategoriesAffected.map((c) => (
          <span
            key={c.id}
            data-testid={`preview-affected-${c.id}`}
            className="sf-mono"
            style={{
              fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase",
              border: "1px solid var(--sf-gold-dim)", color: "var(--sf-gold)",
              padding: "6px 10px", borderRadius: 999,
              backgroundColor: "rgba(201,162,74,0.05)",
            }}
          >
            {c.name} &middot; {String(c.severity || "").toUpperCase()} EXPOSURE
          </span>
        ))}
      </div>
      {(estimatedMonthlyLossMin || estimatedMonthlyLossMax) && (
        <div
          data-testid="preview-categories-combined-loss"
          className="sf-mono"
          style={{
            marginTop: 18, paddingTop: 14, borderTop: "1px dashed #22262B",
            fontSize: 13, color: "var(--sf-offwhite)", lineHeight: 1.55,
          }}
        >
          <span style={{ color: "var(--sf-muted)" }}>
            {leakCategoriesAffected.length} {leakCategoriesAffected.length === 1 ? "system" : "systems"} contributing to an estimated
          </span>{" "}
          <span className="sf-gold">
            ${estimatedMonthlyLossMin?.toLocaleString?.() ?? 0}–${estimatedMonthlyLossMax?.toLocaleString?.() ?? 0}
          </span>{" "}
          <span style={{ color: "var(--sf-muted)" }}>
            in monthly revenue loss. Low end is conservative; high end assumes the gaps stay open.
          </span>
        </div>
      )}
    </div>
  );
}
